import Cookies from 'js-cookie';

import { getMCToken } from '../../../Utils/Utils';
import { constants } from '../../../Constants/Constants';

export const getRealmsCheckHeaders = () => ({
  authorization: getMCToken(),
  ['X-MojangAuth']: Cookies.get(constants.bearerToken),
  applicationType: 'Java',
  microsoftPurchasingToken: localStorage.getItem('MarketplaceXBLToken')
});

export const manageRealmsLink = 'https://accounts.microsoft.com/services';

export const legacyUser = 'Legacy';

export const bedrockEntitlementKey = 'product_minecraft_bedrock';
export const javaEntitlementKey = 'product_minecraft';
